import React, { useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { ParamsSearch } from '../../components/Params/ParamsSearch';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';
import {
  CreateUpdateParamsDto,
  GetParamsDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import {
  convert,
  validate,
} from '../../../common/pokCore/contexts/ParamsContext';
import { ParamsEditor } from '../../components/Params/ParamsEditor';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';

export const ParamsView: React.FC = () => {
  const [param, setParam] = useState<GetParamsDto>();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const pok = usePokCore();
  const { t, tk } = useTranslation('administrationLng');

  const editParam = async (paramCU: CreateUpdateParamsDto, id: string) => {
    const validationResult = await validate(paramCU);
    if (validationResult.valid) {
      try {
        await pok.params.update(id, paramCU);
        setShow(false);
        setRefresh(!refresh);
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: validationResult.errors,
      };
    }
  };

  const onRowClick = async (id: string) => {
    const getParam = await pok.params.getById(id);
    setParam(getParam);
    setShow(true);
  };

  const handleClose = () => {
    setParam(undefined);
    setShow(false);
  };

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.params.getAllByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok, t, tk],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.administration.parameters)}
        </Card.Title>
        <ParamsSearch
          getData={getData}
          getCount={pok.params.getAllCount}
          onRowClick={onRowClick}
          refresh={refresh}
        />
        {param && (
          <ParamsEditor
            param={convert(param)}
            readOnly={!param.isEditable}
            show={show}
            handleClose={handleClose}
            onCompleted={editParam}
            id={param.id}
          />
        )}
      </Card.Body>
    </Card>
  );
};
